import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcFunctionalTest = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={52}
    height={52}
    viewBox="0 0 52 52"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <rect fill="#EEF4FF" width={52} height={52} rx={4} />
      <path
        d="M31.3 42.996c1.704 0 3.093-.922 3.12-2.626v-1.34a.67.67 0 0 1 .65-.64h3.5a1 1 0 0 0 1-1s0 2.3-2.67 4.31c-1.601 1.165-3.53 1.351-5.51 1.356l-.09-.06Z"
        fill="#5590FF"
        fillRule="nonzero"
        opacity={0.6}
      />
      <path
        d="M13.58 9a1.08 1.08 0 0 0-1.09 1.08v31.835a1.08 1.08 0 0 0 1.09 1.08H31.3a3.12 3.12 0 0 0 3.12-3.07v-1.33a.65.65 0 0 1 .65-.64h3.5a1 1 0 0 0 1-1V10.08A1.08 1.08 0 0 0 38.48 9h-24.9Z"
        stroke="#5590FF"
        fill="#D4E4FF"
        fillRule="nonzero"
        strokeLinejoin="round"
      />
      <path
        d="M39.57 37.037s.05 2.625-2.62 4.708c-1.601 1.207-3.55 1.246-5.53 1.25M15.42 40h5-5Z"
        stroke="#5590FF"
        strokeLinecap="round"
      />
      <g stroke="#5590FF">
        <path d="M30.24 18.376c2.049 2.043 3.737 4.573 5.064 7.59 2.403 5.46 4.005 10.468-2.402 10.468-6.408 0-5.907.57-5.907-4.95 0-3.313.521-7.513 1.563-12.598a1 1 0 0 1 1.683-.511Z" />
        <path d="M27.037 27.374c1.129-.616 1.975-1.237 2.538-1.862.563-.624 1.144-1.444 1.743-2.46M26.986 27.451c.677.39 1.196.74 1.558 1.051.361.31.777.827 1.246 1.548M35.164 26.276c-1.608 1.558-2.411 3.278-2.411 5.16v4.952" />
        <path d="M26.937 33.088c1.025-.903 1.958-1.53 2.799-1.885.84-.354 1.908-.568 3.201-.644" />
      </g>
      <g stroke="#5590FF">
        <path d="M21.854 18.376c-2.049 2.043-3.737 4.573-5.064 7.59-2.403 5.46-4.005 10.468 2.403 10.468 6.407 0 5.906.57 5.906-4.95 0-3.313-.52-7.513-1.563-12.598h.001a1 1 0 0 0-1.684-.511Z" />
        <path d="M24.935 27.451c-1.25-.668-2.158-1.314-2.721-1.939-.563-.624-1.144-1.444-1.743-2.46M24.935 27.451c-.765.39-1.328.74-1.69 1.051-.361.31-.777.827-1.246 1.548M16.625 26.276c1.608 1.558 2.411 3.278 2.411 5.16v4.952M25.037 33.088c-1.026-.903-1.959-1.53-2.8-1.885-.84-.354-1.907-.568-3.2-.644" />
      </g>
      <g stroke="#5590FF">
        <path d="M23.732 19.648c1.305-.8 1.305-2.468 1.305-4.69v-2.99h2.447v2.99c0 1.423-.198 3.94 1.164 4.52M24.968 13.527h1.402M24.968 15.527h1.402M24.968 17.527h1.402M24.202 22.239c.576-1.174 1.197-1.761 1.863-1.761.666 0 1.287.587 1.864 1.76" />
      </g>
    </g>
  </svg>
);
export default SvgIcFunctionalTest;
